import React from 'react';
import './TeamMember.css';

const TeamMember = ({ name, position, imageUrl, linkedinUrl, behanceUrl, dribbbleUrl }) => {
    return (
        <div className="card team-member">
            <img src={imageUrl} className="card-img-top" alt={`${name}'s photo`} />
            <div className="card-body text-center">
                <h5 className="card-title">{name}</h5>
                <p className="card-text text-muted">{position}</p>
            </div>
            <div className="card-footer d-flex justify-content-around">
                <a href={linkedinUrl} target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
              
            </div>
        </div>
    );
};

export default TeamMember;
